import ObaNotificacaoModel from "../../model/ObaNotificacaoModel";
import ProxyBaseDAO from "./ProxyBaseDAO";

class ProxyConfiguracaoDAO extends ProxyBaseDAO {
  private static instance: ProxyConfiguracaoDAO;
  private endpoint = `${this.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ProxyConfiguracaoDAO {
    if (!ProxyConfiguracaoDAO.instance) {
      ProxyConfiguracaoDAO.instance = new ProxyConfiguracaoDAO();
    }
    return ProxyConfiguracaoDAO.instance;
  }

  public async getModalData(): Promise<ObaNotificacaoModel[]> {
    return this.get(
      `REQ_OBA_APP_NOTIFICACAO`,
      `${this.endpoint}/Oba/notification`
    ).then((res: any) => ObaNotificacaoModel.toModel(res.data.data));
  }

}

export default ProxyConfiguracaoDAO;